import React, { useCallback, useState } from 'react';
import * as Styles from './AdsHandler.styles';
import {
  Button, IconCheck, IconStarsOutline,
} from 'gatorcomponents';
import imageBR from '@/pages/marketing/AdsHandler/media/img-container_br.png';
import imageES from '@/pages/marketing/AdsHandler/media/img-container_es.png';
import useLocale from '@/hooks/useLocale';
import { isBRServer } from '@/utils/Validators/validation';
import { useResize } from '@/hooks/useResize';
import { Redirect } from 'react-router';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { ATIVACAO_ENABLE_ADS_PAGE } from '@/config/GrowthBook/constants';
import { useAiChat } from '@/hooks/AiChat';
import { Faq } from './components/Faq';
import { useChatbot } from '@/contexts/Chatbot';

export const AdsHandler = () => {
  const { handleOpenMarketingAgent } = useAiChat();
  const { marketing: marketingLocale, routes: routesLocale } = useLocale();
  const chatbot = useChatbot();

  const isChatbotLoading = chatbot.isActive && !chatbot.isReady;

  const [accordionsOpened, setAccordionsOpened] = useState();

  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 960;

  const enableAdsAgent = useFeatureIsOn(ATIVACAO_ENABLE_ADS_PAGE);

  const accordionItem = useCallback(({ item }) => {
    const response = (
      <>
        {item.content.title && (<Styles.FaqItemText>{item.content.title}</Styles.FaqItemText>)}
        {item.content.text && (<Styles.FaqItemText>{item.content.text}</Styles.FaqItemText>)}
        {item.content.list && (
        <Styles.FaqItemInsideList>
          {item.content.list.map(listItem => (
            <Styles.FaqItemInsideListItem key={listItem}>
              {listItem}
            </Styles.FaqItemInsideListItem>
          ))}
        </Styles.FaqItemInsideList>
        )
        }
        {item.content.finishing && (<Styles.FaqItemText>{item.content.finishing}</Styles.FaqItemText>)}
      </>
    );


    return response;
  }, []);

  const openMaiaMarketingAgent = useCallback(() => {
    handleOpenMarketingAgent();
  }, [handleOpenMarketingAgent]);


  const getFaqProps = useCallback(() => ({
    marketingLocale,
    accordionItem,
    accordionsOpened,
    setAccordionsOpened,
  }), [accordionItem, accordionsOpened, marketingLocale, setAccordionsOpened]);


  if (!enableAdsAgent) {
    return (
      <Redirect to={routesLocale.home} />
    );
  }

  return (
    <Styles.Container>
      <Styles.Row>
        <Styles.Column>
          <Styles.WithAi>{marketingLocale.adsHandler.firstRow.tag}</Styles.WithAi>
          <Styles.CardTitle>
            {marketingLocale.adsHandler.firstRow.title}
          </Styles.CardTitle>

          <Styles.List>
            {marketingLocale.adsHandler.firstRow.list.map(item => (
              <Styles.ListItem key={item}>
                <IconCheck size="sm" />
                {item}
              </Styles.ListItem>
            ))}
          </Styles.List>

          <Styles.CtaRow>
            <Button
              disabled={isChatbotLoading}
              loading={isChatbotLoading}
              label={(
                <>
                  {marketingLocale.adsHandler.firstRow.cta}
                  <IconStarsOutline color="highPure" />
                </>
              )}
              onClick={openMaiaMarketingAgent}
              size="large"
              width={isMobile ? 'full' : 'auto'}
            />
            <Styles.CtaDescription>
              {marketingLocale.adsHandler.firstRow.ctaDescription}
            </Styles.CtaDescription>
          </Styles.CtaRow>
        </Styles.Column>

        <Styles.Column>
          <Styles.Image src={isBRServer ? imageBR : imageES} />
        </Styles.Column>
      </Styles.Row>

      <Faq {...getFaqProps()} />
    </Styles.Container>
  );
};

export default AdsHandler;
